import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { siteDefaults, mergeSite } from "@/lib/siteDefaults";

const SiteContext = createContext({ site: siteDefaults, refresh: () => {}, ready: false });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(siteDefaults);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      setSite(mergeSite(data || {}));
    } catch {
      setSite(siteDefaults);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ site, refresh, ready }), [site, refresh, ready]);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
